/*eslint-disable react/no-danger*/
import React, {PropTypes} from 'react';
import TextInput from '../../common/TextInput';
import RadioInput from '../../common/RadioInput';
import Button from '../../common/Button';
import * as InjurySummaryConstants from '../../../constants/InjurySummaryConstants';

const InjurySummaryForm =
  ({
    form,
    establishment,
    onChange,
    onSubmit,
    onClick,
    onCancel,
    onBlur,
    injurySummary,
    submitStatus,
    softErrors,
    errors
  })=> {
    let questions = [];
    let isChecked = '';
    let totalMsg = '';
    let questionMsg = '';
    if(injurySummary['noInjuries'] === InjurySummaryConstants.NO_INJURIES){
      isChecked = true;
    }
    else if(injurySummary['noInjuries'] === InjurySummaryConstants.YES_INJURIES){
      isChecked = false;
    }
    if(errors["generalMessage"]){
      totalMsg = (
        <div className="alert alert-danger"><div className="first-line">
          {errors["generalMessage"]}
        </div></div>);
    }
    if(errors["numberOfCases"] || errors["injuryAndIllnessTypes"]){
     questionMsg = errors["numberOfCases"];
    }
    if (form.formQuestions) {
      form.formQuestions.forEach(question => {
        let questionParts = [];
        let bootstrapClassName = "question-part col-xs-12 col-md-3";
        if(question.questionName === "employeeInformation"){
          bootstrapClassName = "question-part";
        } else if(question.questionId === "injuryAndIllnessTypes"){
          bootstrapClassName = "question-part col-xs-6";
        }
        question.questionParts.map(questionPart => {
          let type = questionPart.questionPartType;
          if (type === '3') { //radio button
            questionParts.push(
              <div className="question-part"
                    key={questionPart.questionPartName}>
                <RadioInput
                  onChange={onClick}
                  label={questionPart.questionPartLabel}
                  name={questionPart.questionPartName}
                  className="establishment-radio-question"
                  fieldClass={questionPart.questionPartName}
                  onBlur={onBlur}
                  error={errors[questionPart.questionPartName]}
                  value={injurySummary[questionPart.questionPartName]}
                  options={questionPart.questionPartOptions}
                  contextHelp={questionPart.questionPartContextHelp}
                  tooltip={questionPart.questionPartTooltipHelp}
                  required={questionPart.questionPartRequired == '1'}
                />
              </div>
            );
          }
          else if(type === '4'){
            if(questionPart.questionPartName === 'annualAverageEmployees' ||
              questionPart.questionPartName === 'totalHoursWorked'){
              isChecked = false;
            }
            else{
              isChecked = (injurySummary['noInjuries'] == InjurySummaryConstants.NO_INJURIES)
              ? true : false;
            }
            questionParts.push (
              <div className={bootstrapClassName}
                    key={questionPart.questionPartName}>
                <TextInput
                  type="text"
                  onChange={onChange}
                  disabled={isChecked}
                  placeHolder={questionPart.questionPartLabel}
                  label={questionPart.questionPartLabel}
                  name={questionPart.questionPartName}
                  value={injurySummary[questionPart.questionPartName]}
                  className = "userCreation-text-input"
                  fieldClass={questionPart.questionPartName}
                  onBlur={onBlur}
                  error={errors[questionPart.questionPartName]}
                  softError={softErrors[questionPart.questionPartName]}
                  contextHelp={questionPart.questionPartContextHelp}
                  tooltip={questionPart.questionPartTooltipHelp}
                  required={questionPart.questionPartRequired == '1'}
                />
              </div>
            );
          }
        });
        if(question.questionName === "employeeInformation"){
          questions.push(
            <div className={question.questionId + " col-xs-12"}
                  key={question.questionName}>
              <h3 className="question-title"> Employment Information </h3>
              {question.questionGroupHelpText &&
                <div dangerouslySetInnerHTML={{__html:question.questionGroupHelpText}}/>}
              <div className="question-div-left">
                {questionParts.slice(0,2)}
              </div>
              <div className="question-div-right">
                {questionParts[2]}
              </div>
            </div>
          );
        }
        else if(question.questionId ==="injuryAndIllnessTypes"){
          questions.push(
            <div className={questionMsg !== ""
            ? (question.questionId + " col-xs-12 has-error-group")
            : (question.questionId + " col-xs-12")}
                key={question.questionName}>
                <div className="col-md-6 col-xs-12 question-group">
              <h3 className="question-title"> {question.questionName} </h3>
                {question.questionGroupHelpText &&
                  <div className="questionGroupContextHelp" dangerouslySetInnerHTML={{__html:question.questionGroupHelpText}}/>}
              <h4 className="number-title"> Total Number Of: </h4>

              <div className="question-row-first row">
                {questionParts[0]}{questionParts[1]}
              </div>
              <div className="question-row-second row">
                {questionParts[2]}{questionParts[3]}
              </div>
              <div className="question-row-third row">
                {questionParts[4]}{questionParts[5]}
              </div>
              {questionMsg !== "" &&
                <div tabIndex="0"className="error-message">
                  <p>{questionMsg}</p>
                </div>}
              </div>
            </div>
          );
        }
        else if(question.questionId ==="numberOfCases"){
          questions.push(
          <div className={questionMsg === ''
            ? (question.questionId + " col-xs-12")
            : (question.questionId + " col-xs-12 has-error-group")}
                key={question.questionName}>
            <div className="question-group">
            <h3 className="question-title"> {question.questionName} </h3>
              {question.questionGroupHelpText &&
                <div className="questionGroupContextHelp" dangerouslySetInnerHTML={{__html:question.questionGroupHelpText}}/>}
            <h4 className="number-title"> Total Number Of: </h4>
            <div className="row">
              {questionParts}
            </div>
            {questionMsg !== "" &&
              <div tabIndex="0"className="error-message">
                <p>{questionMsg}</p>
              </div>}
            </div>
          </div>
        );
        }
        else{
        questions.push(
          <div className={question.questionId + " col-xs-12"}
                key={question.questionName}>
            <h3 className="question-title"> {question.questionName} </h3>
              {question.questionGroupHelpText &&
                <div className="questionGroupContextHelp" dangerouslySetInnerHTML={{__html:question.questionGroupHelpText}}/>}
            <h4 className="number-title"> Total Number Of: </h4>
            <div className="row">
              {questionParts}
            </div>
          </div>
        );
        }
      });

    }
    return (
      <div id="injury-summary-form">
        <div className="panel" id="injury-summary-form-panel">
          <div className="panel-heading">
            <div className="form-instructions"
              dangerouslySetInnerHTML={{__html:form.formPageHelp}}/>
          </div>
          <div className="required-info">
            <span className="required-asterisk">*</span>
            <strong> All Fields are Required </strong>
          </div>
          <div className="panel-body">
            {establishment &&
              <div className="establishment-name">
                Establishment Name: <b>{establishment.establishment_name}</b>
              </div>
            }
            <form>
              {questions}
              {isChecked}
              <div className="msg-container">
              {totalMsg}
              </div>
              <div className="button-container">
                  <Button
                    className="submit-300A pull-right"
                    value={"Submit"}
                    disabled={!submitStatus}
                    onClick={onSubmit}/>
                  <a
                    className="cancel-300A pull-right"
                    disabled={false}
                    href="#"
                    onClick={onCancel}>
                    Cancel
                  </a>

              </div>
            </form>
          </div>
        </div>
      </div>
    );
  };


InjurySummaryForm.propTypes = {
  form: PropTypes.object.isRequired,
  establishment: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  injurySummary: PropTypes.object.isRequired,
  submitStatus: PropTypes.bool.isRequired,
  errors: PropTypes.object,
  softErrors: PropTypes.object
};

export default InjurySummaryForm;



/** WEBPACK FOOTER **
 ** ./src/components/injurySummary/InjurySummaryManagement/InjurySummaryForm.js
 **/